export default __webpack_public_path__ + "static/media/add.d4daf2cf.svg";